import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/raleway-light.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/raleway-regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/raleway-heavy.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/raleway-semi-bold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/raleway-bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22preload%22:false,%22variable%22:%22--font-raleway%22}],%22variableName%22:%22raleway%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'raleway', 'raleway Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
